import React from 'react'

import { Title, Text, NitroImg } from './styles'
import nitro from '../../../assets/img/nitro.png'

function ChallengeDetails(props){
  return(
    <>
      <Title>Description</Title>
      <Text>{ props.desc }</Text>
      <Title>Rewards</Title>
      <Text><NitroImg src={ nitro }/>{ props.reward } Nitro Points</Text>
    </>
  )
}

export default ChallengeDetails